const SET_REPEATED_FROM = 'mrCollection/SET_REPEATED_FROM';

export default {
  SET_REPEATED_FROM,
};
